<template>
  <div>
    <el-dialog
        :title="'Tạo nhận xét tuần, tháng'"
        :visible.sync="showCreateEvaluateWeekMonthDialog"
        width="700px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <div>
        <el-row>
          <el-col :span="2">
            <el-date-picker
                style="width: 150px"
                size="medium"
                v-model="dataInput.dateWeek"
                type="week"
                value-format="yyyy-MM-dd"
                format="Tuần WW"
                placeholder="Chọn tuần"
                :clearable="false"
            ></el-date-picker>
          </el-col>
          <el-col :span="4" :offset="4">
            <el-date-picker
                style="width: 160px"
                size="medium"
                v-model="dataInput.dateMonth"
                type="month"
                value-format="yyyy-MM-dd"
                format="'Tháng 'MM-yyyy"
                placeholder="Chọn tháng"
                :clearable="false"
            ></el-date-picker>
          </el-col>
          <el-col :span="2" :offset="3">
            <el-select
                size="medium"
                v-model="dataInput.idSchool"
                placeholder="Chọn trường"
                filterable
                clearable
                style="width: 250px"
            >
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.id+' - '+item.schoolName"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="2">
            <el-button
                size="small"
                :loading="buttonLoading1"
                @click="createEvaluateWeekMonthRootFromDateManual('evaludateWeek')"
                type="primary"
            >Tạo NX tuần
            </el-button>
          </el-col>
          <el-col :span="2" :offset="4">
            <el-button
                :loading="buttonLoading2"
                size="small"
                @click="createEvaluateWeekMonthRootFromDateManual('evaludateMonth')"
                type="primary"
            >Tạo NX tháng
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    showCreateEvaluateWeekMonthDialog: {
      type: Boolean,
      default: () => false
    },
    schoolList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataInput: {
        dateWeek: "",
        dateMonth: "",
        idSchool: "",
      },
      buttonLoading1: false,
      buttonLoading2: false,
      listSchool: [],
    };
  },

  methods: {
    closeDialog() {
      this.dataInput.dateWeek = "";
      this.dataInput.dateMonth = "";
      this.dataInput.idSchool = "";
      this.buttonLoading1 = false
      this.buttonLoading2 = false
      this.$emit('close', false);
    },
    createEvaluateWeekMonthRootFromDateManual(type) {
      let typeText = type === "evaludateWeek" ? "TUẦN" : "THÁNG";
      let dateInput =
          type === "evaludateWeek"
              ? this.dataInput.dateWeek
              : this.dataInput.dateMonth;
      if (this.dataInput.idSchool === "") {
        this.$message({
          message: "Chọn trường tạo nhận xét " + typeText,
          type: "error",
        });
        throw null;
      }
      if (dateInput === "") {
        this.$message({
          message: "Chọn " + typeText + " tạo nhận xét ",
          type: "error",
        });
        throw null;
      }
      let dataInputNew = {
        date: dateInput,
      };
      let alertText =
          this.dataInput.idSchool === "" ? "cho TOÀN BỘ các trường" : "";
      this.$confirm(
          "Bạn có chắc chắn muốn tạo nhận xét " +
          typeText +
          " " +
          alertText +
          " không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(() => {
        type === "evaludateWeek"
            ? (this.buttonLoading1 = true)
            : (this.buttonLoading2 = true);
        OtherService.createEvaluateWeekMonthRootFromDate(
            type,
            dataInputNew,
            this.dataInput.idSchool
        )
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading1 = false;
                this.buttonLoading2 = false;
              }, 1000);
            });
      });
    },
  },


};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
</style>
